import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';
import ReactGA from 'react-ga';

// import '../css/Map.scss';

const points = [
  {
    time: '',
    bottom: '',
    desc: '',
    audio: process.env.PUBLIC_URL+'audio/MFM_Ayesha_Intro.mp3'
  },
  {
    time: '8:00AM',
    bottom: "Building a clear and trusting communication line between clients and providers is essential to successful maternal health outcomes.  Providers may not be aware of the particular struggles their patients are facing, such as a lack of adequate transportation or fear of losing their job due to excessive time off for appointments. Advocates use this time to speak on behalf of their clients and help resolve any potential issues.",
    desc: "MCC Advocates meet with their clients’ providers at the Hospital of the University of Pennsylvania (HUP)",
    audio: process.env.PUBLIC_URL+'audio/MFM_Ayesha_Intro.mp3'
  },
  {
    time: '9:30AM',
    bottom: "MCC Advocates are dedicated to contacting mothers at least once a week to check on their health and wellbeing. During these conversations they may plan for upcoming appointments, see if they are in need of critical supplies such as clothing, diapers or baby formula, or provide support with any administrative tasks, such as applications, forms or other documentation.",
    desc: "MCC Advocates head to the Safe Start office to call clients and check-in on them.",
    audio: process.env.PUBLIC_URL+'audio/MFM_Ayesha_Location_2.mp3'
  },
  {
    time: '11:00AM',
    bottom: "A vital component of an MCC Advocate’s work is building trust with women who have experienced mistreatment and disrespect from healthcare providers, family members and/or their community. This involves also setting up measurable goals that MCC can help them achieve beyond childbirth.",
    desc: "MCC Advocate meets at the South Philadelphia home of an anxious new client who is 35 weeks into a high-risk pregnancy. ",
    audio: process.env.PUBLIC_URL+'audio/MFM_Liz_Location_3.mp3'
  },
  {
    time: '1:15PM',
    bottom: "MCC Advocates act as liaisons for clients seeking refuge from abusive households, often working directly with shelters on temporary dwellings and the Philadelphia Housing Authority for longer-term placement. They also help locate and schedule behavioral health services for clients who are in need of mental health or substance abuse treatment.",
    desc: "MCC Advocate visits client who has recently moved into an emergency shelter and looking for her own housing.",
    audio: process.env.PUBLIC_URL+'audio/MFM_Ayesha_Location_4.mp3'
  },
  {
    time: '3:00PM',
    bottom: "Navigating the healthcare system shortly after birth can be overwhelming for new moms, so MCC Advocates supply clients with resources to ensure both mom and child are healthy. Safe Start participants are much more likely to attend their postpartum appointments, mostly due to the Advocate’s encouragement and help getting them to the providers.",
    desc: "MCC Advocate visits the Hunting Park home of a client who recently gave birth.",
    audio: process.env.PUBLIC_URL+'audio/MFM_Ayesha_Location_5.mp3'
  },
  {
    time: '4:30PM',
    bottom: "MCC Advocates provide wide-ranging doula services--from helping to develop birth plans, to being on-call for emergencies, to attending births and providing support postpartum. In cases of high-risk pregnancies, they help with navigating the complexities and confusion of the healthcare system to ensuring that mothers receive proper prenatal care. Women often feel trepidation, whether due to a first-time pregnancy or a bad experience with a provider in the past.",
    desc: "MCC Advocate accompanies a patient to her appointment at the Hospital of the University of Pennsylvania (HUP) for a prenatal check-up.",
    audio: process.env.PUBLIC_URL+'audio/MFM_Ayesha_Location_6.mp3'
  }
];


class App extends Component {
  constructor(props) {
    super(props);

    this.state = { audio: points[0].audio, zone: false, time: '', bottom: '', desc: '', sound: null, go: false, section: -1 };

    this.isIE11 = false;

    this._scroll = this._scroll.bind(this);
    this._play = this._play.bind(this);
    this._stop = this._stop.bind(this);
    this._loadAudio = this._loadAudio.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this._scroll);

    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  }

  render() {
    let sectionKey = 'bottom'+this.state.section;
    let section = this.state.section;

    if(this.state.section === 7) {
      sectionKey = 6;
      section = 6;
    }
    return (
      <div className="map map2">
        <div ref="scroll" className={"scroll-area current-section"+section}>
          <div className="map-bg">
            <div className="bg1"></div>
            <div className="bg2"></div>
            <div className="bg3"></div>
            <div className="bg4"></div>
            <div className="bg5"></div>
            <div className="bg6"></div>
          </div>
          <div className="bottom-gradient"></div>
          <div ref="blackout" className="blackout">
            <div className="blackout-copy">
              <h1>The Difference an MCC Advocate Can Make</h1>
              <h3>A Day In The Life of an MCC Advocate</h3>
              <p>An MCC Advocate’s job takes them all over the map to help mothers in need. Here’s a quick glimpse of the typical day in the field for them and the ground they cover in service of bettering maternal health outcomes.</p>
            </div>
          </div>

          <div key={sectionKey} className={!this.state.zone || this.state.bottom === '' ? "bottom-info" : "bottom-info bottom-info-hidden"}>

            <p>{this.state.bottom}</p>

            <div className={this.state.playing ? "audio audio-open" : "audio"}>

              {!this.isIE11 ?
                this.state.playing ? <button onClick={this._play}>Pause</button> : <button onClick={this._play}>Play Advocate Story</button>
              : null }
              <div className="wave" id={"waveform"}></div>

              {
                this.isIE11 ?
                    <div className="audio-player">
                      <audio controls>
                        <source src={this.state.audio} type="audio/mpeg" />
                      </audio>
                    </div>
                    :
                    null
              }
            </div>
          </div>
          <div className="car-holder">
            <div ref="car" className="car">
              {this.state.zone ?
                <div ref="callout" className="arrow-box">
                  <h3>{this.state.time}</h3>
                  {this.state.desc }
                </div>
              : null }
              <div ref="carInner" className="car-inside"></div>
            </div>
            <div className="map-points">
              <div ref="point0" className="map-point0"></div>
              <div ref="point1" className="map-point1"></div>
              <div ref="point2" className="map-point2"></div>
              <div ref="point3" className="map-point3"></div>
              <div ref="point4" className="map-point4"></div>
              <div ref="point5" className="map-point5"></div>
              <div ref="point6" className="map-point6"></div>
            </div>
          </div>
        </div>

      </div>
    );
  }

  _scroll(e) {
    const fromTop = this.refs.scroll.getBoundingClientRect().top;
    const h = window.innerHeight;
    if(fromTop <= 0) {
      let section = Math.floor((-1 * fromTop) / h);
      let pct = (-1 * fromTop) / h - section;

      // if(section === 6 && pct > 0.98) {
      //   pct = 0;
      //   section = 7;
      // }

      if(section === 5 && pct > 0.98) {
        pct = 0;
        section = 6;
      }

      const p1 = {
      	x: 0,
      	y: 0
      };

      const p2 = {
      	x: 0,
      	y: 0
      };

      switch(section) {
        default:
        case 0:
          this.refs.car.style.opacity = pct;
          this.refs.car.style.top = this.refs.point0.getBoundingClientRect().top*pct + 'px';
          this.refs.car.style.left = this.refs.point0.getBoundingClientRect().left*pct + 'px';
          p2.x = this.refs.point0.getBoundingClientRect().left;
          p2.y = this.refs.point0.getBoundingClientRect().top;
        break;

        case 1:
          this.refs.car.style.opacity = pct;
          this.refs.car.style.top = this.refs.point1.getBoundingClientRect().top*pct + 'px';
          this.refs.car.style.left = this.refs.point1.getBoundingClientRect().left*pct + 'px';
          p2.x = this.refs.point1.getBoundingClientRect().left;
          p2.y = this.refs.point1.getBoundingClientRect().top;
        break;
        case 2:
          this.refs.car.style.top = this.refs.point1.getBoundingClientRect().top + (this.refs.point2.getBoundingClientRect().top - this.refs.point1.getBoundingClientRect().top) * pct + 'px';
          this.refs.car.style.left = this.refs.point1.getBoundingClientRect().left + (this.refs.point2.getBoundingClientRect().left - this.refs.point1.getBoundingClientRect().left) * pct + 'px';

          p1.x = this.refs.point1.getBoundingClientRect().left;
          p1.y = this.refs.point1.getBoundingClientRect().top;

          p2.x = this.refs.point2.getBoundingClientRect().left;
          p2.y = this.refs.point2.getBoundingClientRect().top;

        break;
        case 3:
          this.refs.car.style.top = this.refs.point2.getBoundingClientRect().top + (this.refs.point3.getBoundingClientRect().top - this.refs.point2.getBoundingClientRect().top) * pct + 'px';
          this.refs.car.style.left = this.refs.point2.getBoundingClientRect().left + (this.refs.point3.getBoundingClientRect().left - this.refs.point2.getBoundingClientRect().left) * pct + 'px';

          p1.x = this.refs.point2.getBoundingClientRect().left;
          p1.y = this.refs.point2.getBoundingClientRect().top;

          p2.x = this.refs.point3.getBoundingClientRect().left;
          p2.y = this.refs.point3.getBoundingClientRect().top;
        break;
        case 4:
          this.refs.car.style.top = this.refs.point3.getBoundingClientRect().top + (this.refs.point4.getBoundingClientRect().top - this.refs.point3.getBoundingClientRect().top) * pct + 'px';
          this.refs.car.style.left = this.refs.point3.getBoundingClientRect().left + (this.refs.point4.getBoundingClientRect().left - this.refs.point3.getBoundingClientRect().left) * pct + 'px';

          p1.x = this.refs.point3.getBoundingClientRect().left;
          p1.y = this.refs.point3.getBoundingClientRect().top;

          p2.x = this.refs.point4.getBoundingClientRect().left;
          p2.y = this.refs.point4.getBoundingClientRect().top;
        break;
        case 5:
          this.refs.car.style.top = this.refs.point4.getBoundingClientRect().top + (this.refs.point5.getBoundingClientRect().top - this.refs.point4.getBoundingClientRect().top) * pct + 'px';
          this.refs.car.style.left = this.refs.point4.getBoundingClientRect().left + (this.refs.point5.getBoundingClientRect().left - this.refs.point4.getBoundingClientRect().left) * pct + 'px';

          p1.x = this.refs.point4.getBoundingClientRect().left;
          p1.y = this.refs.point4.getBoundingClientRect().top;

          p2.x = this.refs.point5.getBoundingClientRect().left;
          p2.y = this.refs.point5.getBoundingClientRect().top;
        break;
        case 6:
          this.refs.car.style.top = this.refs.point5.getBoundingClientRect().top + (this.refs.point6.getBoundingClientRect().top - this.refs.point5.getBoundingClientRect().top) * pct + 'px';
          this.refs.car.style.left = this.refs.point5.getBoundingClientRect().left + (this.refs.point6.getBoundingClientRect().left - this.refs.point5.getBoundingClientRect().left) * pct + 'px';

          p1.x = this.refs.point5.getBoundingClientRect().left;
          p1.y = this.refs.point5.getBoundingClientRect().top;

          p2.x = this.refs.point6.getBoundingClientRect().left;
          p2.y = this.refs.point6.getBoundingClientRect().top;

        break;
        // case 7:
        //   this.refs.car.style.top = this.refs.point6.getBoundingClientRect().top+'px';
        //   this.refs.car.style.left = this.refs.point6.getBoundingClientRect().left + 'px';

        //   p1.x = this.refs.point5.getBoundingClientRect().left;
        //   p1.y = this.refs.point5.getBoundingClientRect().top;

        //   p2.x = this.refs.point6.getBoundingClientRect().left;
        //   p2.y = this.refs.point6.getBoundingClientRect().top;

        // break;
      }


      // if(section == 7 ) return;
      if(section == 6 ) return;


      if(section === 0) {
        this.refs.blackout.style.opacity = 1-pct;
      } else {
        this.refs.blackout.style.opacity = 0;
      }

      let captionSection = section;
      if(captionSection > points.length-1) {
        captionSection = 6;
      }
      if(pct > .5 && !this.state.zone) {
        this.setState({zone: true}, () => this._loadAudio());

      } else {
        if(pct <= 0.5 && this.state.zone && section !== 7) {
          //this.wavesurfer = null;
          if(this.wavesurfer) this.wavesurfer.destroy();
          this.setState({zone: false});
        }
      }

      if(this.state.section !== section) {
        this.setState({section});
        this._stop();
      }

      // angle in degrees
      const angleDeg = Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;

      this.refs.carInner.style.transform = 'translate(-40px, -10px) rotate('+angleDeg+'deg)';


      if(this.state.time !== points[captionSection].time) {
        this.setState({audio: points[captionSection].audio, time: points[captionSection].time, bottom: points[captionSection].bottom, desc: points[captionSection].desc });
      }

    } else {
      if(this.state.section !== -1) {
        this.setState({section: -1});
      }
    }
  }

  _play() {
    if(!this.wavesurfer) return;
    console.log(this.state.playing);
    if(this.state.playing) {
      this.wavesurfer.pause();
      this.setState({playing: false});
    } else {
      this.wavesurfer.play();
      this.setState({playing: true});
      ReactGA.event({
        category: 'Play Advocate Story',
        action: 'Clicked Play Button'
      });
    }

    console.log('clicked!');
  
    
  }

  _stop() {
    if(!this.wavesurfer) return;
    this.wavesurfer.pause();
    this.setState({playing: false});
    //this._loadAudio();
  }

  _loadAudio() {
    console.log('Audio Loaded.');
    if(!this.isIE11) {
      if(this.wavesurfer) this.wavesurfer.destroy();
      this.wavesurfer = WaveSurfer.create({
          container: '#waveform',
          waveColor: '#ccc',
          progressColor: '#10887D',
          barWidth: 3,
          height: 50
      });

      //this._loadAudio();
    }

    console.log(this.state.section);
    if(this.state.section === -1) return;

    if(this.state.audio && this.wavesurfer) {
      this.wavesurfer.load(this.state.audio);
    }

  }

}

export default App;



// WEBPACK FOOTER //
// ./src/js/Map2.js